import { render, staticRenderFns } from "./AccountTab.vue?vue&type=template&id=1c4e70a6&"
import script from "./AccountTab.vue?vue&type=script&lang=js&"
export * from "./AccountTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports